import runtime from "../runtime"
import macAltMap from "./macAltMap"
import macShiftAltMap from "./macShiftAltMap";

// text2key 根据用户所给的快捷键(text), 返回当前环境(electron/browser, windows/linux/darwin)对应的需要绑定的实际 keys
// 主要是经过 shift 的大小写转换, 以及 mac 下的 alt 自符转换
function text2key(text) {
    if (!text) return ""
    let rawWords = text.split("+")

    let lowerText = text.toLowerCase()
    let words = lowerText.split("+")

    let hasAlt = lowerText.indexOf("alt") === -1 ? false : true
    let hasCtrl = lowerText.indexOf("ctrl") === -1 ? false : true
    let hasShift = lowerText.indexOf("shift") === -1 ? false : true

    let key = ""
    for (let i in words) {
        let W = rawWords[i].trim()

        let w = words[i].trim()
        if (w.length === 1) {
            if (runtime.isWindows() && hasShift) {
                W = w.toUpperCase()
            }
            if (runtime.isDarwin() && hasAlt && !hasCtrl) {
                if (hasAlt && !hasCtrl) {
                    W = macAltMap.getText(w)
                }
                if (hasAlt && hasShift) {
                    W = macShiftAltMap.getText(w)
                }
            }
        }

        key += key.length === 0 ? W : ("+" + W)
    }

    return key
}

function texts2keys(texts) {
    if (!texts) {
        console.debug("Warning: texts2keys: texts:", texts)
        return []
    }
    let keys = []
    for (let text of texts) {
        keys.push(text2key(text))
    }
    return keys
}

export default {
    text2key,
    texts2keys,
}
